import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-[#1a1a1a] text-white py-24">
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#DD0000]/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#FFCE00]/8 rounded-full blur-[100px]"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Rota Berlin Hakkında
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              Almanya'da eğitim ve iş hayatında yılların deneyimiyle, Berlin merkezli profesyonel danışmanlık hizmeti sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="flex flex-col gap-6">
              <div className="relative rounded-lg overflow-hidden shadow-xl">
                <img
                  src="https://static.readdy.ai/image/e51399e73e35a4762b4f070880195b49/f17e173b419b59185525ecf29975c219.jpeg"
                  alt="Sebahat - Yönetici ve Eğitim Danışmanı"
                  className="w-full h-[340px] object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <div className="flex items-center gap-2">
                    <div className="px-3 py-1 bg-[#DD0000] text-white text-xs font-semibold rounded-full flex items-center gap-1">
                      <i className="ri-vip-crown-line"></i>
                      <span>Yönetici</span>
                    </div>
                  </div>
                  <h3 className="text-white text-lg font-bold mt-1">Sebahat</h3>
                  <p className="text-white/80 text-sm">Eğitim Danışmanı</p>
                </div>
              </div>
              <img
                src="https://public.readdy.ai/ai/img_res/1baa25445af404050ce4930a7545f27f.jpg"
                alt="Rota Berlin Ofis"
                className="w-full h-[280px] object-cover rounded-lg shadow-xl"
              />
            </div>
            <div>
              <div className="inline-block bg-[#DD0000] text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                Hikayemiz
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Almanya'da Eğitim Yolculuğunuzun Güvenilir Partneri
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Rota Berlin, Türkiye merkezli bir eğitim ve kariyer danışmanlığı firması olarak Almanya'da eğitim almak isteyen öğrencilere profesyonel danışmanlık hizmetleri sunmaktadır. Danışmanlık sürecimiz, Türkiye'deki merkez ofisimizden yönetilmekte; Almanya'daki eğitim kurumları ve resmi süreçlerle uyumlu şekilde planlı ve şeffaf olarak yürütülmektedir.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Başvuru aşamasından kabul, vize ve yerleşime kadar tüm süreçlerde öğrencilerimize kesintisiz destek sağlayarak, Almanya'daki eğitim yolculuklarına güvenli bir başlangıç yapmalarını hedefliyoruz.
              </p>
              <div className="flex gap-4">
                <Link
                  to="/services"
                  className="bg-[#DD0000] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#bb0000] transition-colors whitespace-nowrap"
                >
                  Hizmetlerimiz
                </Link>
                <Link
                  to="/contact"
                  className="border-2 border-[#DD0000] text-[#DD0000] px-8 py-3 rounded-lg font-semibold hover:bg-[#DD0000]/5 transition-colors whitespace-nowrap"
                >
                  İletişime Geç
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-[#DD0000]/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-flag-line text-3xl text-[#DD0000]"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h3>
                <p className="text-gray-700 leading-relaxed">
                  Türkiye'den Almanya'ya eğitim için gelen öğrencilere, başvuru sürecinden mezuniyete kadar her aşamada profesyonel, güvenilir ve kesintisiz destek sağlamak. Öğrencilerimizin Almanya'daki eğitim ve kariyer hedeflerine ulaşmalarında en güvenilir yol arkadaşı olmak.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-[#FFCE00]/20 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-eye-line text-3xl text-[#FFCE00]"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Vizyonumuz</h3>
                <p className="text-gray-700 leading-relaxed">
                  Almanya'da eğitim almak isteyen uluslararası öğrenciler için en güvenilir ve tercih edilen danışmanlık firması olmak. Deneyimimizi ve yerel bilgimizi kullanarak, öğrencilerin Almanya'daki eğitim yolculuklarını başarıyla tamamlamalarını sağlamak.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-[#DD0000] text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
              Neden Rota Berlin?
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bizi Farklı Kılan Özellikler
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              20 yılı aşkın Almanya deneyimi ve başarı hikayeleriyle dolu bir ekip
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#DD0000]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-[#DD0000]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Deneyimli Ekip</h3>
              <p className="text-gray-700 leading-relaxed">
                Almanya'nın eğitim ve iş hayatında 20 yılı aşkın deneyime sahip, başarı hikayeleriyle dolu bir ekip rehberliğinde hizmet sunuyoruz. Ekibimiz, Almanya'daki resmi ve sosyal süreçlere hakimdir.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#FFCE00]/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-map-pin-line text-3xl text-[#FFCE00]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Yerinde ve Sürekli Destek</h3>
              <p className="text-gray-700 leading-relaxed">
                Berlin merkezli danışmanlık firmamız, sadece uzaktan değil, yerinde ve sürekli destek sağlar. Almanya'ya varduktan sonra kültürel adaptasyon, sosyal hayata entegrasyon ve iş dünyasında ilk adımlar için profesyonel yardım alabilirsiniz.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-[#1a1a1a] rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Kişiselleştirilmiş Çözümler</h3>
              <p className="text-gray-700 leading-relaxed">
                Her bireyin ihtiyaçlarının farklı olduğunu biliyoruz. Dil okulu, üniversite veya iş başvuru süreçlerini hedeflerinize göre kişiselleştiriyor ve başarıya giden yolda size özel çözümler sunuyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-[#1a1a1a] text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Değerlerimiz</h2>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              Rota Berlin olarak çalışmalarımızı şekillendiren temel değerlerimiz
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#DD0000]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-4xl text-[#FFCE00]"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Güvenilirlik</h3>
              <p className="text-gray-300">
                Şeffaf ve dürüst iletişim ile öğrencilerimizin güvenini kazanıyoruz
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#DD0000]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-4xl text-[#FFCE00]"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Kalite</h3>
              <p className="text-gray-300">
                Her aşamada en yüksek kalite standartlarını koruyoruz
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#DD0000]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-4xl text-[#FFCE00]"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Destek</h3>
              <p className="text-gray-300">
                7/24 kesintisiz iletişim ve destek hizmeti sunuyoruz
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#DD0000]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-4xl text-[#FFCE00]"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Yenilikçilik</h3>
              <p className="text-gray-300">
                Sürekli gelişen eğitim sistemine ayak uyduruyoruz
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-[#DD0000] text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
              İletişim
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bizimle İletişime Geçin
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Sorularınız için bize ulaşın, size yardımcı olmaktan mutluluk duyarız
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Contact Info */}
            <div>
              <div className="bg-white p-8 rounded-xl shadow-lg mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">İletişim Bilgileri</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#FFCE00]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-xl text-[#FFCE00]"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Türkiye Ofis</h4>
                      <p className="text-gray-600">
                        Esentepe M. Mithat Ulu Ünlü S.<br />
                        No: 26/26 Şişli / İstanbul
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#FFCE00]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-xl text-[#FFCE00]"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">Telefon</h4>
                      <p className="text-gray-600">
                        <a href="tel:+902129126797" className="hover:text-[#DD0000]">0212 912 67 97</a> (Ofis)
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#1a1a1a] rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">E-posta</h4>
                      <p className="text-gray-600">
                        <a href="mailto:rotaberlinn@gmail.com" className="hover:text-[#DD0000]">rotaberlinn@gmail.com</a>
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-green-100/50 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-whatsapp-line text-xl text-green-400"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">WhatsApp</h4>
                      <p className="text-gray-400 text-sm">
                        Şu an aktif değil
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Çalışma Saatleri</h3>
                <div className="space-y-3 text-gray-600">
                  <div className="flex justify-between">
                    <span>Pazartesi - Cuma:</span>
                    <span className="font-semibold">09:00 - 18:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Cumartesi:</span>
                    <span className="font-semibold">10:00 - 14:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Pazar:</span>
                    <span className="font-semibold text-[#DD0000]">Kapalı</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Bize Mesaj Gönderin</h3>
              <form 
                data-readdy-form
                action="https://readdy.ai/api/form/d654kf2jj9tn0ksglmmg"
                method="POST"
                className="space-y-6"
                onSubmit={(e) => {
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  
                  const name = formData.get('name') as string;
                  const email = formData.get('email') as string;
                  const phone = formData.get('phone') as string;
                  const message = formData.get('message') as string;

                  if (!name || !email || !phone || !message) {
                    e.preventDefault();
                    alert('Lütfen tüm alanları doldurun.');
                    return;
                  }

                  if (message.length > 500) {
                    e.preventDefault();
                    alert('Mesajınız 500 karakteri geçemez.');
                    return;
                  }

                  const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                  if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = 'Gönderiliyor...';
                  }
                }}
              >
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-base"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-base"
                    placeholder="ornek@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefon *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-base"
                    placeholder="+90 5XX XXX XX XX"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-700 mb-2">
                    Konu
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-base"
                  >
                    <option value="Genel Bilgi">Genel Bilgi</option>
                    <option value="Lisans Programları">Lisans Programları</option>
                    <option value="Yüksek Lisans Programları">Yüksek Lisans Programları</option>
                    <option value="Dil Okulu">Dil Okulu</option>
                    <option value="Vize İşlemleri">Vize İşlemleri</option>
                    <option value="Konaklama">Konaklama</option>
                    <option value="Diğer">Diğer</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mesajınız * (Maksimum 500 karakter)
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#DD0000] focus:border-transparent text-base resize-none"
                    placeholder="Mesajınızı buraya yazın..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#DD0000] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#bb0000] transition-colors text-lg whitespace-nowrap"
                >
                  Mesaj Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Ofisimizi Ziyaret Edin</h2>
            <p className="text-xl text-gray-600">İstanbul ofisimizde yüz yüze görüşme imkanı</p>
          </div>
          <div className="max-w-6xl mx-auto">
            <div className="rounded-xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.2!2d29.0108!3d41.0628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab7a2a2a2a2a2%3A0x0!2sEsentepe%20Mah.%20Mithat%20Ulu%20%C3%9Cnl%C3%BC%20Sk.%20No%3A26%2F26%2C%20%C5%9Ei%C5%9Fli%2C%20%C4%B0stanbul!5e0!3m2!1str!2str!4v1234567892"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Rota Berlin Türkiye Ofis - Esentepe M. Mithat Ulu Ünlü S. No: 26/26 Şişli İstanbul"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1a1a1a] text-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Almanya'da Eğitim Hayalinizi Gerçekleştirin
            </h2>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Ücretsiz danışmanlık için bugün bizimle iletişime geçin. Deneyimli ekibimiz, Almanya'daki eğitim yolculuğunuzda size rehberlik etmeye hazır.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:rotaberlinn@gmail.com"
                className="bg-[#DD0000] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#bb0000] transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-mail-line text-2xl"></i>
                E-posta Gönder
              </a>
              <a
                href="tel:+902129126797"
                className="bg-[#FFCE00] text-[#1a1a1a] px-8 py-4 rounded-lg font-semibold hover:bg-[#e6b800] transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-phone-line text-2xl"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
